// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__nBj9N","insightsList":"newBusinessInsightsMenu_insightsList__29Sch","active":"newBusinessInsightsMenu_active__1A0Ak"};